
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/money-idioms-explanation';
const mainimage = '/Images/idioms1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "moneyidioms" },
];


const MoneyIdioms = () => (
  <GrammarPageLayout
    level="B2"
    title="Money Idioms"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Money Idioms Exercises"
    seoDescription="Understand everyday expressions about money, spending and saving, from footing the bill to making ends meet. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default MoneyIdioms;
